import { VerificationPending } from '@/screens/verification-pending';

export default function VerificationPendingScreen() {
  return <VerificationPending />;
}
